module.exports = __webpack_public_path__ + "static/media/referralBottom.d5f629ef.png";